const c = (e) => e !== null && typeof e == "object", o = (e) => c(e) && e.nodeType === Node.ELEMENT_NODE, u = (e) => {
  if (!o(e))
    return !1;
  const t = e.ownerDocument.defaultView ?? window;
  return e instanceof t.HTMLElement;
}, r = (e) => o(e) ? e.ownerDocument ?? document : document, m = (e) => e ? "" : void 0, w = (e) => r(e)?.activeElement, d = (e, t) => e ? e === t || e.contains(t) : !1, E = (e) => {
  const { key: t, keyCode: n } = e;
  return n >= 37 && n <= 40 && t.indexOf("Arrow") !== 0 ? `Arrow${t}` : t;
};
export {
  d as contains,
  m as dataAttr,
  w as getActiveElement,
  r as getOwnerDocument,
  o as isElement,
  u as isHTMLElement,
  E as normalizeEventKey
};
//# sourceMappingURL=index.js.map
